import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorsLayoutRoute, vendorsMainRoute } from '..';

export const fundingsRoute = createRoute({
  getParentRoute: () => vendorsLayoutRoute,
  path: 'fundings',
  component: lazyRouteComponent(() => import('./CampaignsList')),
  validateSearch: z.object({
    page: z.coerce.number().optional(),
    search: z.coerce.string().optional(),
    fundingsModalOpen: z.boolean().optional(),
  }).parse,
});

export const singleCampaignRoute = createRoute({
  getParentRoute: () => vendorsMainRoute,
  path: 'fundings/campaign/$campaignName',
  component: lazyRouteComponent(() => import('./CampaignDetailsView')),

  validateSearch: z.object({
    page: z.coerce.number().optional(),
    search: z.coerce.string().optional(),
    from: z.string().optional(),
  }).parse,
  parseParams: (params) => ({
    campaignName: z.string().parse(params.campaignName),
  }),
});
